module.exports = __webpack_public_path__ + "media/images/career_camp/bottom-figures-de0e3e15e8cad8c783178d38a6ca49ed.svg";